export default __webpack_public_path__ + "static/media/mode-65.45ed83f0.svg";